import React from "react";
import { useTranslation } from "react-i18next";
import { IAccordionData } from "../../commonTypes";
import AccordionBox from "../Accordion/AccordionBox";
import { AccordionParagraph } from "../styled";

interface IArtistAccordionProps {
  openOnMount?: boolean;
}

const ArtistTermsAndConditions = ({
  openOnMount = false,
}: IArtistAccordionProps) => {
  const { t } = useTranslation();
  const detailsAccordionData: IAccordionData[] = [
    {
      title: "signup-details-accordion-first-title",
      checkboxName: "confirm_no_copyright",
      paragraphs: (
        <AccordionParagraph>
          {t("signup-details-accordion-first-description")}
        </AccordionParagraph>
      ),
    },
    {
      title: "signup-details-accordion-second-title",
      checkboxName: "confirm_ownership",
      paragraphs: (
        <AccordionParagraph>
          {t("signup-details-accordion-second-description")}
        </AccordionParagraph>
      ),
    },
    {
      title: "signup-details-accordion-third-title",
      checkboxName: "confirm_listening_rights",
      paragraphs: (
        <AccordionParagraph>
          {t("signup-details-accordion-third-description")}
        </AccordionParagraph>
      ),
    },
  ];

  return (
    <AccordionBox content={detailsAccordionData} openOnMount={openOnMount} />
  );
};

export default ArtistTermsAndConditions;
